export default __webpack_public_path__ + "static/media/Commander's Legguards of the Shining Sun.038360d8.jpg";